import { LoanProduct } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/LoanProduct';
import { Text } from '@/components/shared/components/Text';
export const LoanProductOptions = Object.keys(LoanProduct).map((product) => ({
  value: product.toLowerCase(),
  display: <Text tId={product.toLowerCase()} />,
}));
